/* global axios */
import ApiClient from './ApiClient';

class SubscriptionAPI extends ApiClient {
  constructor() {
    super('subscription', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  getPaymentHistory() {
    return axios.get(
      `${this.url.replace('/subscription', '/payment_history')}`
    );
  }

  checkPlanLimits() {
    return axios.get(
      `${this.url.replace('/subscription', '/plan_limits/check')}`
    );
  }
}

export default new SubscriptionAPI();
